import { Link } from 'react-router-dom';
import { Paragraph } from 'uiKit/atoms/Typography/components/Paragraph';
import { Typography } from 'uiKit/atoms/Typography/Typography';
import DocumentModalContent from './DocumentModalContent';

type TermsDocumentsProps = {
  open: boolean;
  closeHandlerTwo: () => void;
  agreeHandlerTwo: () => void;
};

export const TermsDocuments = ({ open, closeHandlerTwo, agreeHandlerTwo }: TermsDocumentsProps) => (
  <DocumentModalContent
    title="Privacy Policy"
    open={open}
    agreeHandler={agreeHandlerTwo}
    closeHandler={closeHandlerTwo}
  >
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      General
    </Typography>
    <Paragraph>
      This Policy is adopted by DataArt Solutions, Inc. its subsidiaries, affiliated companies, and other members of
      enterprise group (“DataArt”). We are committed to protecting any personal data of users of this website and
      lawfully processing such data per relevant legislation and, for that reason, we have adopted this Privacy Policy
      (the “Policy”) to memorialize terms and conditions on data collection to be applied on this site. By using or
      accessing the Service, you agree to the terms of this Privacy Policy. Capitalized terms not defined here have the
      meanings set forth in the terms and conditions (the “Terms and Conditions”), located at&nbsp;
      <Link to="/terms" target="_blank" rel="noopener noreferrer" className="decorated">
        {'https://bns.dataart.com/terms/'}
      </Link>
      . We may update our Privacy Policy to reflect changes to our information practices.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Information we collect{' '}
    </Typography>
    <Paragraph>
      {'When you use '}
      <Link to="/" target="_blank" rel="noopener noreferrer" className="decorated">
        {' '}
        https://bns.dataart.com/
      </Link>
      you provide us with three types of information:
    </Paragraph>
    <Paragraph className="pl-30 mb-0">1. Information you provide when you sign in to use the Service;</Paragraph>
    <Paragraph className="pl-30 mb-0">2. Information you submit via the Service;</Paragraph>
    <Paragraph className="pl-30">
      3. Information regarding your use of the Service collected by us as you interact with the Service.
    </Paragraph>
    <Paragraph className="pl-30 mb-0">1. Information you provide when you sign in to use the Service;</Paragraph>
    <Paragraph className="pl-30 mb-0">2. Information you submit via the Service;</Paragraph>
    <Paragraph className="pl-30">
      3. Information regarding your use of the Service collected by us as you interact with the Service.
    </Paragraph>
    <Paragraph>
      The information you give us may include but not limited to your name, e-mail address, phone number,
      location, photos. When you enter the Website, we collect your browser type and your IP address (a unique address
      that identifies your computer on the Internet). In addition, we store certain information from your browser using
      &quot;cookies&quot;. We are not to collect any personal information unless you login to the site and give us your
      consent. We commit to protect your personal information. You can ask us to delete this information as described
      below. We do not share your personal information with third-parties unless it is necessary to offer the Service or
      required by law (see below for specifics).
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Use of information
    </Typography>
    <Paragraph>
      DataArt including controlled undertakings, personnel, officers, insurers, professional advisers, agents, suppliers
      or subcontractors, that are bound by corporate data protection standards will use information:
    </Paragraph>
    <Paragraph className="pl-30 mb-0">
      1. To administer our site and for internal operations, including troubleshooting, data analysis, testing,
      research, statistical and survey purposes.
    </Paragraph>
    <Paragraph className="pl-30 mb-0">
      2. To improve our site to ensure that content is presented in the most effective manner for you and for your
      computer.
    </Paragraph>
    <Paragraph className="pl-30 mb-0">3. To allow you to use the Service.</Paragraph>
    <Paragraph className="pl-30 mb-0">4. As part of our efforts to keep our site safe and secure.</Paragraph>
    <Paragraph className="pl-30 mb-0">
      5. To send you service-related notifications and announcements from time to time through the general operation of
      the Service. When you use the Service, you may submit information and content to your profile or send messages and
      otherwise transmit information to other users. We store this information so that we can provide you the Service.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Legal basis for collection of personal data{' '}
    </Typography>
    <Paragraph> We collect your personal data based on your consent(s). </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Transfer and storage of your personal data{' '}
    </Typography>
    <Paragraph>
      {' '}
      By consenting our collection and processing of your personal data, you hereby agree on international transfer of
      your data subject to the terms described below. Data that we collect from you may be transferred to, and stored
      at, a destination outside the European Economic Area (&quot;EEA&quot;) and outside the UK. It may also be
      processed by staff operating outside the EEA and the UK who provide support services. Transfers will only be made
      to countries which are the subject of an adequacy decision of the EU Commission and/or ICO authority or recipients
      who have entered into binding contracts with us to comply with the terms of this Privacy Policy and privacy
      legislation. By consent with this Privacy Policy and submitting your personal data, you agree to this transfer,
      storing or processing. We will take all steps reasonably necessary to ensure that your data is treated securely
      and in accordance with this Privacy Policy. DataArt has implemented administrative and technical safeguards it
      believes are sufficient to protect the confidentiality, integrity and availability of your personal information.
      We will keep your personal data secure by taking appropriate technical and organizational measures against its
      unauthorized or unlawful processing and against its accidental loss, destruction or damage. All information you
      provide to us is stored on our secure servers. Your Personal information will not be kept for longer than is
      necessary to fulfill the purpose for which the personal data was collected. When the personal data that we have
      collected is no longer required, we will delete it in a secure manner. We may process data for statistical
      purposes, but in such cases, data will be anonymized.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Sharing your personal-identifiable information with third parties{' '}
    </Typography>
    <Paragraph>
      {' '}
      DataArt shares your personally-identifiable information only when it is reasonably necessary to offer the Service,
      legally required, or permitted by you. We may provide personally-identifiable information to service providers who
      help us bring you the Service, such as hosting the Service. In connection with these operations, our service
      providers may have access to personally-identifiable information for a limited time. When we utilize service
      providers for processing any personally-identifiable information, we implement reasonable contractual protections
      limiting the use of that personally-identifiable information to the provision of services to DataArt.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Disclosure of your personally-identifiable information{' '}
    </Typography>
    <Paragraph>
      {' '}
      We may be required to disclose personally-identifiable information in response to lawful requests, such as
      subpoenas or court orders, or in compliance with applicable laws. This may include sharing personally-identifiable
      information with other companies, lawyers, agents or government agencies.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Updating or deleting your personally-identifiable information{' '}
    </Typography>
    <Paragraph>
      {' '}
      You have at all times the right to delete your account by sending a query to&nbsp;
      <Link to="mailto:privacy@dataart.com" target="_blank" rel="noopener noreferrer" className="decorated">
        {'privacy@dataart.com'}
      </Link>
      &nbsp;with the “Delete DataArt BNS account” title. After your account is deleted, we will retain aggregate or
      anonymous data collected through the Service, including Activity Data, which may be used by us and shared with
      third parties in any manner. Information associated with the Service may be collectively deleted from your
      account, but anonymized examination data may be kept indefinitely by DataArt to improve the examination and for
      research and analysis.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Links{' '}
    </Typography>
    <Paragraph>
      {' '}
      The Service may contain links to other websites. We are not responsible for the privacy practices of other
      websites. We encourage users to be aware when they leave the Service to read the privacy statements of other
      websites that collect personally identifiable information. This Privacy Policy applies only to information
      collected by DataArt via the Service.
    </Paragraph>
    <Typography variant="h4" style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
      {' '}
      Your rights to your personal data{' '}
    </Typography>
    <Paragraph>As a data subject, you have a number of rights. You can:</Paragraph>
    <Paragraph className="pl-30 mb-0">1. Access and obtain a copy of your data on request;</Paragraph>
    <Paragraph className="pl-30 mb-0">2. Correct inaccurate or incomplete personal data held by us;</Paragraph>
    <Paragraph className="pl-30 mb-0">
      3. Erasure right - require DataArt to delete or stop processing your data, for example where the data is no longer
      necessary for the purposes of processing;
    </Paragraph>
    <Paragraph className="pl-30 mb-0">4. Withdraw any consent to personal data processing at any time;</Paragraph>
    <Paragraph className="pl-30 mb-0">
      5. The right to request a restriction on further data processing, in case there is a dispute in relation to the
      accuracy or processing of your personal data;
    </Paragraph>
    <Paragraph className="pl-30 mb-0">
      6. Complain with a supervisory authority. Any query about your Privacy Rights should be sent to&nbsp;
      <Link to="mailto:privacy@dataart.com" target="_blank" rel="noopener noreferrer" className="decorated">
        {'privacy@dataart.com'}
      </Link>
      &nbsp;with “DataArt BNS Privacy Rights Query” title and your name inside.
    </Paragraph>
  </DocumentModalContent>
);
